import React from "react";
import { useTranslation } from "react-i18next";
import {
  BsChatSquareQuoteFill,
  BsFillDiagram3Fill,
  BsUpload,
} from "react-icons/bs";
import { MdWork } from "react-icons/md";
import { RiUserFill, RiGroupFill, RiRadarFill } from "react-icons/ri";
import { NavLink } from "react-router-dom";
// import CustomScrollbars from "util/CustomScrollbars";

const SidenavFunc = ({ setPageTitle, userSignOut, resellerShower }) => {
  const { t } = useTranslation();
  return (
    <>
      {/*
     <CustomScrollbars className=" scrollbar">
     */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <ul className="nav-menu">
          <li
            onClick={() => setPageTitle(t("sidenav.users"))}
            className="map_tooltip menu no-arrow"
          >
            <NavLink to="/app/users">
              <span className="d-flex flex-column align-items-center gap-1">
                <RiUserFill fontSize="20" />
                <span className="pt-1">{t("sidenav.users")}</span>
              </span>
              {/*<div className="nav-text" style={{marginRight: "-0.2rem", fontSize: "10px"}}>*/}
              {/*    کاربران*/}
              {/*</div>*/}
            </NavLink>
          </li>
          <li
            onClick={() => setPageTitle(t("sidenav.groups"))}
            className="map_tooltip menu no-arrow"
          >
            <NavLink to="/app/groups">
              <span className="d-flex flex-column align-items-center">
                <RiGroupFill fontSize="20" />
                <span className="pt-1">{t("sidenav.groups")}</span>
              </span>
            </NavLink>
          </li>

          <li
            onClick={() => setPageTitle(t("sidenav.dispatch"))}
            className="map_tooltip menu no-arrow"
          >
            <NavLink to="/app/map">
              <span className="d-flex flex-column align-items-center">
                <RiRadarFill fontSize="20" />
                <span className="pt-1">{t("sidenav.dispatch")}</span>
              </span>
            </NavLink>
          </li>
          <li
            onClick={() => setPageTitle(t("sidenav.mission"))}
            className="map_tooltip menu no-arrow"
          >
            <NavLink to="/app/missions">
              <span className="d-flex flex-column align-items-center">
                <MdWork fontSize="20" />
                <span className="pt-1">{t("sidenav.mission")}</span>
              </span>
            </NavLink>
          </li>

          <li
            onClick={() => setPageTitle(t("sidenav.chat"))}
            className="map_tooltip menu no-arrow"
          >
            <NavLink to="/app/chat">
              <span className="d-flex flex-column align-items-center">
                <BsChatSquareQuoteFill fontSize="20" />
                <span className="pt-1">{t("sidenav.chat")}</span>
              </span>
            </NavLink>
          </li>

          {resellerShower === true && (
            <li
              onClick={() => setPageTitle(t("sidenav.tenant"))}
              className="map_tooltip menu no-arrow"
            >
              <NavLink to="/app/tenant">
                <span className="d-flex flex-column align-items-center">
                  <BsFillDiagram3Fill fontSize={"20"} />
                  <span className="pt-1">{t("sidenav.tenant")}</span>
                </span>
              </NavLink>
            </li>
          )}
        </ul>
        <ul className="nav-menu" style={{ marginBottom: "50px" }}>
          <li className="map_tooltip no-arrow " role="button">
            <div
              onClick={() => {
                userSignOut();
              }}
            >
              <span className="d-flex flex-column align-items-center">
                <BsUpload
                  fontSize={"24"}
                  color={"white"}
                  style={{ transform: `rotate(90deg)` }}
                />
              </span>
            </div>
          </li>
        </ul>
      </div>
      {/* </CustomScrollbars> */}
    </>
  );
};

export default SidenavFunc;
